import * as React from 'react';
import Layout from '../berry/layout/index.jsx';
import ThemeCustomization from 'src/berry/themes';
import { UserDeffer } from 'src/context/user.jsx';
import { JSONProvider, JSONDeffer } from 'src/context/json.jsx';
import { LanguagesProvider } from 'src/context/languages.jsx';
import { ModalsProvider } from 'src/context/modals.jsx';

import Modals from 'src/controllers/modals.jsx';

const Dashboard = () => {
	return (
		<ThemeCustomization>
			<UserDeffer>
				<JSONProvider>
					<JSONDeffer>
						<ModalsProvider>
							<LanguagesProvider>
								<Modals />
								<Layout />
							</LanguagesProvider>
						</ModalsProvider>
					</JSONDeffer>
				</JSONProvider>
			</UserDeffer>
		</ThemeCustomization>
	);
};

export default Dashboard;
